<template>
  <div>
    <div v-if="canShowBanner" class="environment-banner" :class="bannerData.class">
      <i class="fa-light" :class="bannerData.icon"></i>
      <span class="environment-words">{{environmentFriendlyText}}</span>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import Environment from '@/scripts/environment';

export default defineComponent({
  name: 'EnvironmentBanner',
  computed: {
    environmentFriendlyText () {
       if (Environment.environment === 'localhost') {
        return 'Local';
      } else if (Environment.environment === 'development') {
        return 'Dev';
      } else if (Environment.environment === 'staging') {
        return 'UAT';
      } else if (Environment.environment !== 'prod') {
        return Environment.environment;
      } else {
        return '';
      }
    },
    canShowBanner () {
      return Environment.environment !== 'prod';
    },
    bannerData () {
      let data = { icon: '', class: Environment.environment };
      if (Environment.environment === 'localhost') {
        data.icon = 'fa-globe';
      } else if (Environment.environment === 'development') {
        data.icon = 'fa-display-code';
      } else if (Environment.environment === 'staging') {
        data.icon = 'fa-microscope';
      } else if (Environment.environment !== 'prod') {
        data.icon = 'fa-vial';
      } else {
        data = { icon: '', class: '' };
      }
      return data;
    }
  }
});
</script>

<style lang="scss" scoped>
@import '@/style.scss';
.environment-banner {
  margin-left: 20px;
  display: flex;
  align-self: center;
  padding: 5px;
  cursor: pointer;
  color: white;
}
.localhost {
  background-color: $color-success;
}
.development {
  background-color: $color-warning;
}
.staging {
  background-color: $color-error;
}
.environment-words {
  line-height: 1;
  padding-left: 10px;
  padding-right: 10px;
}
</style>
